export enum OrganisationType {
  BUYER = "BUYER",
  SUPPLIER = "SUPPLIER",
}

export interface WorkspaceFeatures {
  createAssessment?: boolean;
}

export interface Workspace {
  name: string;
  id: string;
  authorId: string;
  createdDate: string;
  userType: ValueOf<typeof UserType>;
  features?: WorkspaceFeatures;
}
export type ValueOf<T> = T[keyof T];

export interface Organisation {
  name: string;
  id: string;
  createdDate: string;
  organisationType: OrganisationType;
  workspaces?: Workspace[];
  userType: ValueOf<typeof UserType>;
  joinCondition: "INVITE" | "AUTO";
}

export const UserType = {
  OWNER: "OWNER",
  ADMIN: "ADMIN",
  MEMBER: "MEMBER",
  GUEST: "GUEST",
  WORKSPACE_ADMIN: "WORKSPACE_ADMIN",
} as const;

export interface User {
  name: string;
  id: string;
  email: string;
  createdDate: string;
  avatar?: string;
  jobTitle?: string;
  organisations: Organisation[];
  permissions: Permissions;
  userType: ValueOf<typeof UserType>;
}

export interface OtherUser {
  name: string;
  email: string;
  createdDate: string;
  id: string;
  jobTitle: string;
  workspaces: {
    id: string;
    name: string;
    userType: ValueOf<typeof UserType>;
  }[];
  userType: ValueOf<typeof UserType>;
  workspaceCount: number;
}

export type Actions =
  | "read"
  | "*"
  | "share"
  | "add-assessment"
  | "update"
  | "activate"
  | "create"
  | "delete"
  | "deadline"
  | "deadline-post-activate";

interface Permissions {
  [workspaceId: string]: {
    [resourceType: string]: {
      [resourceId: string]: Actions[];
    };
  };
}

export interface InvitedUser {
  createdDate: string;
  id: string;
  email: string;
  dateInvite: string;
  invitedBy: {
    name: string;
    id: string;
  };
  organisationId: string;
  organisationName: string;
  workspaceId: string;
  workspaceName: string;
  userType: ValueOf<typeof UserType>;
  status: "ACCEPT" | "DECLINE" | "PENDING" | "CANCELLED";
}

export interface OrganisationDomain {
  domain: string;
  organisationId: string;
  verificationId?: string;
  verificationEmail?: string;
  verified: boolean;
  createdDate: string;
  authorId: string;
}

export interface OrganisationInfo {
  name: string;
  id: string;
  createdDate: string;
  organisationType: OrganisationType;
  workspaces?: Record<string, Workspace>;
  domain: string[];
  joinCondition: "INVITE" | "AUTO";
  website?: string;
}

export interface Request {
  authorId: string;
  createdDate: string;
  email: string;
  organisationId: string;
  userType: keyof typeof UserType;
  userId: string;
  workspaceId: string;
}

export interface Notification {
  id: string;
  userId: string;
  message: string;
  read: boolean;
  createdDate: string;
  eventType: string;
  organisationId: string;
  workspaceId?: string;
  resourceType?: string;
  resourceId?: string;
}
